import React, { useState } from 'react';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import { displayedName } from 'four-nets/user/utils';
import { AuthorSideFragment } from 'four-nets/photoblog/user-blog/author-side/author-side.graphql';
import UpdateVendorInfo from 'four-nets/vendor/update-vendor-info/update-vendor-info';
import Badge from 'four-nets/ui-v2/badges/highlighted-badge/highlighted-badge';
import { Props as BadgeProps } from 'four-nets/ui-v2/badges/badge/badge';

import { VendorInformationFragment } from '../vendor-information/vendor-information.graphql';
import defaultStyles from './author-name.scss';

export interface Props {
    styles: typeof defaultStyles;
    user: AuthorSideFragment;
    isActive?: boolean;
    isAuthor?: boolean;
    vendor?: VendorInformationFragment;
}

export const StyledBadgeInactive = (props: Omit<BadgeProps, 'styles'>) => (
    <Badge style={{ badge: defaultStyles.badgeInactive }} {...props} />
);

function AuthorName(props: Props) {
    const { styles, vendor, user, isAuthor, isActive } = props;
    const displayUsername = vendor && vendor.name ? vendor.name : displayedName(user);

    const [open, setOpen] = useState(false);

    return (
        <>
            {vendor ? (
                <div className={styles.flexDiv}>
                    <UpdateVendorInfo
                        open={open}
                        setOpen={(value: boolean = false) => setOpen(value)}
                        vendor={vendor}
                    />
                    <Badge style={{ badge: defaultStyles.badge }} uppercase={true}>
                        <FormattedMessage id='PROFESIONAL' />
                    </Badge>
                    {isAuthor ? (
                        <button className={styles.editButton} onClick={() => setOpen(true)}>
                            <FormattedMessage id='EDIT_VENDOR_INFORMATION' />
                        </button>
                    ) : null}
                </div>
            ) : isActive ? (
                <Badge style={{ badge: defaultStyles.badge }} uppercase={true}>
                    <FormattedMessage id='ACTIVE_USER' />
                </Badge>
            ) : (
                <StyledBadgeInactive uppercase={true}>
                    <FormattedMessage id='INACTIVE_USER' />
                </StyledBadgeInactive>
            )}
            <h1 className={styles.username}>{displayUsername}</h1>
        </>
    );
}

export default Styled(defaultStyles)(AuthorName);
